import { useContext, useState } from 'react';
import { UserContext } from '../../context/UserProvider';
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

export const Perfil = () => {
  const { user } = useContext(UserContext);
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();
  const [formData, setFormData] = useState({
    displayName: user?.displayName || '',
    email: user?.email || '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Aquí iría la lógica para actualizar el perfil
    setIsEditing(false);
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  // Unificar lógica de imagen de perfil
  const avatarURL = user.avatarURL || user.photoURL;
  const initial =
    (user.displayName && user.displayName[0]) ||
    (user.email && user.email[0]) ||
    "?";

  if (!user) {
    return (
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={8}>
            <Card className="text-center">
              <Card.Body>
                <h2>No has iniciado sesión</h2>
                <p>Por favor, inicia sesión para ver tu perfil.</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card>
            <Card.Body>
              <div className="text-center mb-4">
                {avatarURL ? (
                  <img
                    src={avatarURL}
                    alt="avatar"
                    style={{
                      width: 150,
                      height: 150,
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "3px solid #5F9EA1",
                    }}
                  />
                ) : (
                  <div
                    className="nav-user-avatar nav-user-initial mx-auto"
                    style={{
                      width: 150,
                      height: 150,
                      borderRadius: "50%",
                      background: "#5F9EA1",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      fontSize: 70,
                      border: "3px solid #5F9EA1",
                    }}
                  >
                    {initial.toUpperCase()}
                  </div>
                )}
              </div>

              {isEditing ? (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      type="text"
                      name="displayName"
                      value={formData.displayName}
                      onChange={handleInputChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      disabled
                    />
                  </Form.Group>

                  <div className="d-flex justify-content-end gap-2">
                    <Button variant="secondary" onClick={() => setIsEditing(false)}>
                      Cancelar
                    </Button>
                    <Button variant="primary" type="submit">
                      Guardar cambios
                    </Button>
                  </div>
                </Form>
              ) : (
                <>
                  <div className="mb-4">
                    <h3>{user.displayName || 'Usuario'}</h3>
                    <p className="text-muted">{user.email}</p>
                    {user.roles && (
                      <div className="mt-2">
                        <strong>Roles:</strong> {user.roles.join(", ")}
                      </div>
                    )}
                    {user.nivelSuscripcion !== undefined && (
                      <div className="mt-2">
                        <strong>Nivel de suscripción:</strong> {user.nivelSuscripcion}
                      </div>
                    )}
                  </div>

                  <div className="d-flex justify-content-end gap-2">
                    <Button variant="danger" onClick={handleLogout}>
                      Cerrar sesión
                    </Button>
                    <Button variant="primary" onClick={() => setIsEditing(true)}>
                      Editar perfil
                    </Button>
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}; 